import React, { useState } from 'react';
const faqs = [{
  q: "Come ricevo il Megapack dopo l'acquisto?",
  a: "L'accesso è immediato. Appena confermi il pagamento, ricevi un'email con il tuo link di download e puoi iniziare a usare il kit in meno di 5 minuti, da tablet, smartphone o PC."
}, {
  q: 'Va bene per istruttrici con poca esperienza?',
  a: "Assolutamente sì! Il kit è pensato sia per istruttrici nuove che hanno bisogno di struttura, sia per professioniste con anni di esperienza che cercano di ottimizzare il tempo. I 6 volumi includono progressioni chiare dal principiante all'avanzato."
}, {
  q: 'Funziona per Reformer e Matwork?',
  a: 'Sì. Il Megapack include volumi specifici sia per Reformer che per Mat Pilates con piccoli attrezzi (bande, palline, magic circle e altro). È un sistema completo, non solo una modalità.'
}, {
  q: 'I 6 bonus sono inclusi nel prezzo?',
  a: 'Sì, i 6 bonus strategici (Playlist, Anamnesi, Variazioni 3 Livelli, Calendario Annuale, Script Prima Lezione e Pack di Flyer) sono inclusi senza costi aggiuntivi in questa offerta di lancio.'
}, {
  q: 'Cosa succede con allieve di livelli diversi nello stesso momento?',
  a: 'La Guida Variazioni in 3 Livelli (Bonus 03) risolve esattamente questo. Hai lo stesso esercizio in versione Fondamentale, Standard e Avanzata — mostri le 3 e ogni allieva sceglie quella adatta.'
}, {
  q: 'Va bene se faccio lezioni online?',
  a: 'Sì. Le routine e le pianificazioni funzionano perfettamente per lezioni in presenza 1 a 1, di gruppo in studio e anche per lezioni online via Zoom o video. Tu scegli il formato.'
}, {
  q: 'In che formato arrivano i file?',
  a: 'Tutto il materiale arriva in PDF di alta qualità, ottimizzato per la visualizzazione su tablet, smartphone e PC, o per la stampa se preferisci portarlo su carta in studio. Non serve alcun software speciale.'
}, {
  q: 'Per quanto tempo ho accesso al materiale?',
  a: 'Accesso a vita. Una volta scaricato, il kit è 100% tuo per sempre — senza abbonamenti, senza pagamenti ricorrenti, senza date di scadenza.'
}, {
  q: "C'è una garanzia di rimborso?",
  a: "Sì, hai 7 giorni di garanzia totale. Se non è quello che ti aspettavi, ti restituiamo il 100% dei soldi senza domande, senza moduli e senza procedure complicate. Il nostro tasso di rimborso è inferiore all'1%."
}, {
  q: 'Come posso pagare? È sicuro?',
  a: 'Accettiamo carte di credito, debito e metodi locali. Il pagamento di €19 viene elaborato tramite un gateway 100% sicuro e criptato. I tuoi dati non vengono mai condivisi.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-bg-main py-20 sm:py-24 px-4" data-id="element-152">
      <div className="max-w-3xl mx-auto" data-id="element-153">
        <div className="text-center mb-10 sm:mb-12" data-id="element-154">
          <p className="inline-block bg-primary/10 text-primary font-bold uppercase tracking-wider text-[11px] sm:text-xs px-3 py-1.5 rounded-full border border-primary/20 mb-4" data-id="element-155">
            ❓ Risolviamo i tuoi dubbi
          </p>
          <h2 className="text-3xl sm:text-5xl font-black text-text-main tracking-tight" data-id="element-156">
            Domande frequenti
          </h2>
        </div>

        <div className="space-y-3 sm:space-y-4 mb-12 sm:mb-16" data-id="element-157">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className={`bg-bg-alt border rounded-2xl overflow-hidden transition-colors duration-300 ${isOpen ? 'border-primary/50 shadow-[0_8px_24px_-12px_rgba(139,111,191,0.25)]' : 'border-border-light hover:border-primary/20'}`} data-id="element-158">
                <button className="w-full text-left px-5 sm:px-6 py-4 sm:py-5 flex items-center justify-between gap-4" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} data-id="element-159">
                  <span className={`font-bold text-base sm:text-lg transition-colors ${isOpen ? 'text-primary' : 'text-text-main'}`} data-id="element-160">
                    {faq.q}
                  </span>
                  <span className={`text-2xl flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-45 text-primary' : 'text-text-sec'}`} data-id="element-161">
                    +
                  </span>
                </button>
                <div className={`px-5 sm:px-6 overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 pb-5 sm:pb-6 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-162">
                  <p className="text-text-sec text-sm sm:text-base leading-relaxed" data-id="element-163">
                    {faq.a}
                  </p>
                </div>
              </div>;
        })}
        </div>

        <div className="text-center relative" data-id="element-164">
          <a href="#pricing" className="relative btn-primary-pulse bg-cta-green font-black text-base sm:text-2xl px-8 sm:px-12 py-4 sm:py-5 rounded-2xl hover:bg-cta-green-hover transition-all inline-block mb-4 w-full sm:w-auto max-w-2xl text-white shadow-[0_15px_40px_-10px_rgba(15,139,111,0.5)]" data-id="element-165">
            🚀 SÌ! VOGLIO IL MEGAPACK COMPLETO
          </a>
          <p className="text-text-sec text-xs sm:text-sm font-medium flex items-center justify-center gap-2 flex-wrap" data-id="element-166">
            <span data-id="element-167">⚡ Accesso immediato</span>
            <span data-id="element-168">•</span>
            <span data-id="element-169">🛡️ Garanzia 7 giorni</span>
            <span data-id="element-170">•</span>
            <span data-id="element-171">💳 €19 pagamento unico</span>
          </p>
        </div>
      </div>
    </section>;
}